import React from 'react';

export default function Button({
  label,
  color = 'secondary',
  action = () => {},
}: {
  label: string;
  color: string;
  action: () => void;
}): JSX.Element {
  const className = `TinyEditableContent__btn btn btn-${color} mr-2`;

  return (
    <button type="button" onClick={action} className={className}>
      {label}
    </button>
  );
}
